import { V2, newV2 } from './lib/V2';

export class Transform {
  position: V2;
  scale: V2;
  rotation: number;
  parent: Transform | null;
  constructor(source?: Partial<Transform>) {
    this.position = source?.position || newV2();
    this.scale = source?.scale || newV2(1, 1);
    this.rotation = source?.rotation || 0;
    this.parent = source?.parent || null;
  }
}
